<template>
  <div class="gameplan">
    <div v-loading="loading">
      <el-row>
        <el-col :span="24" class="content-right">
          <div class="search">
            <el-form :inline="true" :model="queryParams" ref="searchForm" class="searchForm">
              <el-form-item class="item" prop="prNumber">
                <el-input v-model="queryParams.prNumber" placeholder="PR编码" size="small" clearable/>
              </el-form-item>
              <el-form-item class="item" prop="prName">
                <el-input v-model="queryParams.prName" placeholder="PR名称" size="small" clearable/>
              </el-form-item>
              <el-form-item class="item" prop="brandCode" clearable>
                <el-select v-model="queryParams.brandCode" placeholder="选择品牌" size="small" clearable>
                  <el-option v-for="item in btmpBrandDTOList" :key="item.brandCode" :label="item.brandDisplayName" :value="item.brandCode">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="item-btn">
                <el-button type="danger" size="small" @click="getGameplanThemeUnconfiguredList()">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="info" size="small" @click="resetForm()">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-if="prList.length>0">
            <div class="normal_box margin_bottom_20 is_hover_shadow" v-for="item of prList" :key="item.prNumber">
              <div class="pr_item">
                  <div class="pr_item_left">
                    <div class="pr_title">
                      活动名称待配置
                    </div>
                    <div class="pr_info">
                      <div  class="pr_info_item">PR编码：{{item.prNumber}}</div>
                      <div  class="pr_info_item">PR名称：{{item.prName}}</div>
                    </div>
                    <div class="pr_info">
                      <div class="pr_info_brand color_blue">{{item.brandName}}  {{(item.brandName&&item.subBrandName)?'-':''}} {{item.subBrandName}}</div>
                      <div class="pr_info_brand color_yellow">待配置</div>
                    </div>
                    <div class="pr_date">活动时间：待配置</div>
                  </div>
                  <div class="pr_item_right min-width-300">
                    <div class="pr_status">待配置</div>
                    <div class="pr_operation_btn_box">
                      <div class="pr_operate_btn_white" @click="handleUpdatePr(item.prNumber)">退回PR</div>
                      <div class="pr_operate_btn_white" @click="handleChoose(item.prName,item.brandName,item.subBrandName,item.prNumber)">从历史配置复制</div>
                      <div class="pr_operate_btn" @click="gotoWeb(item.prName,item.brandName,item.subBrandName,item.prNumber)">新配置</div>
                    </div>
                  </div>
                </div>
            </div>
          </div>

          <div v-else class="no_data">暂无数据</div>
          <!-- <div class="pagination">
            <el-pagination background :total="total" layout="total, prev, pager, next" :current-page="queryParams.page"
              :page-size="queryParams.pageSize" @current-change="handleCurrentChange" />
          </div> -->
        </el-col>
      </el-row>
    </div>

    <el-dialog title="选择" :visible.sync="dialog" width="750px"
      :close-on-click-modal="false">
      <div v-loading="dialogLoading">
        <div class="normal_box margin_bottom_20 border_grey" v-for="item of themeList" :key="item.themeId">
            <div class="pr_item">
              <div class="pr_item_left">
                <div class="pr_title">
                  {{item.themeName}}
                </div>
                <div class="pr_info">
                  <div class="pr_info_item">PR编码：{{item.gpPrDTO&&item.gpPrDTO.prNumber}}</div>
                  <div class="pr_info_item">PR名称：{{item.gpPrDTO&&item.gpPrDTO.prName}}</div>
                </div>
                <div class="pr_info">
                  <div class="pr_info_brand color_blue">{{item.gpPrDTO&&item.gpPrDTO.brandName}} {{(item.gpPrDTO&&item.gpPrDTO.brandName&&item.gpPrDTO.subBrandName)?'-':''}} {{item.gpPrDTO&&item.gpPrDTO.subBrandName}}</div>
                  <div class="pr_info_brand color_yellow">{{getThemeChannels(item.themeChannels)}}</div>
                </div>
                <div class="pr_date">活动时间：{{ item.themeStartTime | parseTime("{y}-{m}-{d}") }} -  {{ item.themeEndTime | parseTime("{y}-{m}-{d}") }} </div>
              </div>
              <div class="pr_item_right">
                <div class="pr_operation_btn_box">
                  <div class="pr_operate_btn_white" @click="gotoConfig(item.themeId)">选择</div>
                </div>
              </div>
            </div>
        </div>
        <div class="pagination">
          <el-pagination background :total="total" layout="total, prev, pager, next" :current-page="queryParams.page"
            :page-size="queryParams.pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange" />
        </div>
      </div>


      <span slot="footer" class="dialog-footer">
        <!-- <el-button  style="margin-right:20px" size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button  size="small" type="danger" @click="beSure()">确 定</el-button> -->
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { mapGetters,mapState } from 'vuex'
import gameplanApi from "@/api/gameplan";
export default {
  name: 'activity-management',

  data() {
    return {
      loading:false,
      dialogLoading:false,
      queryParams: {
        page: 1,
        pageSize: 5,
        queryCondition:'03,05',
        prNumber: '', // PR编码
        prName:'', // PR名称

        brandCode: '', // 选择品牌
      },
      searchForm: {
        prId: '', // PR编码
        prName: '', // PR名称
        activityName: '', // 活动名称
        selectBrand: '', // 选择品牌
        selectChannel: '', // 选择渠道
      },
      btmpBrandDTOList:[],
      prList:[],
      themeList:[],
      total:0,
      dialog:false,
      item:{}
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    ...mapState({
      gpThemeChannelMap:state=> state.base.gpThemeChannelMap,
    }),
  },
  created() {
    this.getGameplanThemeUnconfiguredList()
    //this.getGameplanConfigFull()
    this.getGameplanConfigIgniteOptions()
    this.getGameplanConfigByChannel()
    this.getGamepalnBrandquery()
    this.getGameplanThemeList()
  },
  methods: {
    async getGameplanThemeUnconfiguredList() {
      this.loading = true
      const { data } = await gameplanApi.getGameplanThemeUnconfiguredList(this.queryParams);
      if (data.resultCode === "0") {
        this.prList = data.resultData?.prList || [];
        //this.total = data.resultData.pageInfo.totalCounts
      }
      this.loading = false
    },
    async getGameplanThemeList(page,pageSize) {
      this.dialogLoading = true
      page?this.queryParams.page=page:''
      pageSize?this.queryParams.pageSize=pageSize:''
      const { data } = await gameplanApi.getGameplanThemeList(this.queryParams);
      if (data.resultCode === "0") {
        this.themeList = data.resultData?.themeList || [];
        this.total = data.resultData.pageInfo.totalCounts
      }
      this.dialogLoading = false
    },
    async getGamepalnBrandquery() {
      const { data } = await gameplanApi.getGamepalnBrandquery();
      if (data.resultCode === "0") {
        this.btmpBrandDTOList = data.resultData?.btmpBrandDTOList || [];
      }
    },
    async getGameplanConfigIgniteOptions() {
      const { data } = await gameplanApi.getGameplanConfigIgniteOptions();
      if (data.resultCode === "0") {
        this.igniteOptions = data.resultData?.igniteOptions || {};
      }
    },
    async getGameplanConfigByChannel() {
      let params ={
        channelCode:'01'
      }
      const { data } = await gameplanApi.getGameplanConfigByChannel(params);
      if (data.resultCode === "0") {
        //this.igniteOptions = data.resultData?.igniteOptions || {};
      }
    },
    async getGameplanConfigFull() {
      const { data } = await gameplanApi.getGameplanConfigFull();
      if (data.resultCode === "0") {
        this.fullConfig = data.resultData?.fullConfig || [];
        this.assignBuList = data.resultData?.assignBuList || []
        //this.total = data.resultData.pageInfo.totalCounts
      }
    },
    async handleUpdatePr(prNumber){
      this.$confirm('是否要申请退回PR，不关联活动配置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(async() => {
          let params = {
            prNumber,
            processAction:'01'
          }
          const { data } = await gameplanApi.getGameplanPRPOUpdatePr(params);
          if (data.resultCode === "0") {
            this.$message.success("申请退回成功！");
            this.getGameplanThemeUnconfiguredList()
            this.resetForm()
          } else {
            this.$message.error(data.resultMsg);
          }
        }).catch(() => {
        });
    },
    handleChoose(prName,brandName,subBrandName,prNumber){
      this.item = {
        prName,brandName,subBrandName,prNumber
      }
      this.dialog = true
    },
    getThemeChannels(themeChannels){
      let result = ''
      for(let item of themeChannels){
        result+=item.themeChannelEnName + '、'
      }
      return result.substr(0, result.length - 1);
    },
    handleCurrentChange(val) {
      this.queryParams.page = val
      this.getGameplanThemeList()
    },
    handleSizeChange (val) {
      this.queryParams.pageSize = val
      this.getGameplanThemeList()
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.getGameplanThemeUnconfiguredList()
    },
    gotoWeb(prName,brand,subBrand,prNumber,themeId,isHistory) {
      this.$router.push({ path:'/gameplan/activity-configure-hq', query:{prName,brand,subBrand,prNumber,themeId,isHistory}})
    },
    gotoConfig(themeId){
      this.$router.push({ path:'/gameplan/activity-configure-hq', query:{prName:this.item.prName,brand:this.item.brandName,subBrand:this.item.subBrandName,prNumber:this.item.prNumber,themeId,isHistory:true}})
    },
    // 关联PO
    relevancePo() { }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-pagination{
  text-align: center;
  margin-top: 20px;
}
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}

.trade-nav-panel {
  width: 80%;
  margin: 0 auto;
  background: $base-white;

  //   .el-menu-item:last-child{
  //     border-bottom: 0;
  //   }
  ::v-deep .el-card__header {
    height: 70px;
    line-height: 35px;
  }

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
    color: #CD1231;
  }

  ::v-deep .el-menu {
    border-right: 0;
  }

  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;
  //   .content-left,
  .content-right {
    height: 100%;
    box-sizing: border-box;
    a {
      text-decoration: none;
      color: #000;
    }

    .search {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .item {
        width: 120px;
      }
      .item-btn {
        margin-left: 30px;
      }
    }

    .pagination {
      position: relative;
      bottom: 0;
    }
  }
.pagination .el-pagination {
  text-align: center;
}
  .content-left {
    padding-right: $content-middle;
  }
}

.pr_item{
  ::v-deep .el-card__body{
      padding: 15px;
    }
}

.block{
  //margin-top: 20px;
  //background-color: rgba(0, 0, 0, 1);
  width: 100%;
  height: 30px;
}
.trade-nav-panel-sp{
  margin-top: 30px;
}
.no_data{
  text-align: center;
  padding: 100px 0;
}
.border_grey{
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}
</style>
